import { createRouter, createWebHistory } from "vue-router";
import PaperChat from './components/PaperChat.vue';
import HomePage from './components/HomePage.vue';
import LoginPage from './components/Login.vue'
import LandingPage from "./components/LandingPage.vue";
import ContactPage from "./components/ContactPage.vue";
import ProfilePage from "./components/ProfilePage.vue";
import AboutPage from './components/AboutPage.vue'
import SignupPage from './components/SignupPage.vue'

const router = createRouter({
  history : createWebHistory(),
  routes: [
    {
      path : '/',
      component: HomePage
    },
    {
      path: '/paper/:p',
      component: PaperChat
    },
    {
      path: "/login",
      name: "Login",
      component: LoginPage,
    },
    {
      path: "/landing",
      name: "Landing",
      component: LandingPage,
    },
    {
      path: "/contact",
      name: "Contact",
      component: ContactPage,
    },
    {
      path: "/profile",
      name: "Profile",
      component: ProfilePage,
    },
    {
      path: '/about',
      name: 'About',
      component: AboutPage,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/signup',
      name: 'Signup',
      component: SignupPage
    }
  ]
});

export default router;